import { declareString } from "@1js/localization";

export const AllPromptLabel = declareString("promptLibrary.promptTabAll", {
  text: "All prompts",
  comment: "Label used on the prompt tab component to show all Copilot prompts",
});

export const SavedPromptLabel = declareString("promptLibrary.promptTabSaved", {
  text: "Saved",
  comment:
    "Label used on the prompt tab component to show all saved Copilot prompts (user-authored or Microsoft created)",
});

export const BookmarkedPromptsLabel = declareString(
  "promptLibrary.promptTabBookmarked",
  {
    text: "Bookmarked",
    comment:
      "Label used on the prompt tab component to show all bookmarked Copilot prompts (user-authored or Microsoft created)",
  }
);

export const SuggestedPromptsLabel = declareString(
  "promptLibrary.promptTabSuggested",
  {
    text: "Suggested",
    comment:
      "Label used on the prompt tab component to show suggested Copilot prompts (user-authored or Microsoft created)",
  }
);

export const GroupPromptsLabel = declareString("promptLibrary.promptTabGroup", {
  text: "Team prompts",
  comment:
    "Label used on the prompt tab component to show group Copilot prompts (user-authored or Microsoft created shared with a workgroup in an organization)",
});

export const MyPromptsLabel = declareString("promptLibrary.promptTabMy", {
  text: "My prompts",
  comment:
    "Label used on the prompt tab component to show user-authored Copilot prompts",
});

export const MicrosoftPromptsLabel = declareString(
  "promptLibrary.promptTabMicrosoft",
  {
    text: "Microsoft prompts",
    comment:
      "Label used on the prompt tab component to show Microsoft-authored Copilot prompts",
  }
);

export const YourPromptsLabel = declareString(
  "promptLibrary.promptTabYourPrompts",
  {
    text: "Your prompts",
    comment:
      "Label used on the prompt tab component to show all the saved prompts",
  }
);
